

import { backendExceptionHandler } from "@/mixins";
import FormatterService from "@/service/FormatterService";

export default {
    name: "SharePerformance",
    mixins: [backendExceptionHandler],

    props: {
        share: Object
    },

    data() {
        return {
            isInitializing: true,
            performance: null
        }
    },

    async fetch() {
        this.isInitializing = true
        return this
            .$axios
            .get('/api/shares/performance?isin=' + this?.share?.isin)
            .then(response => {
                this.performance = response.data.performance
            })
            .catch(error => {
                this.performance = null
                this.handleBackendException(error, this.$t('component.share.sharePerformance.errors.marketIdentifiersLoadFailed'))
            })
            .finally(() => {
                this.isInitializing = false
            })
    },

    watch: {
        async share() {
            await this.$fetch()
        },
    },

    created() {
        this.format = new FormatterService({
            currency: 'EUR'
        })
    },
}
